// Category icons and colors for groups
import { 
  Users, BookOpen, Heart, Music, Briefcase, Baby, Dumbbell, GraduationCap,
  HandHeart, MessageCircle, Coffee, Cross
} from "lucide-react";

export const categoryIcons = {
  "General": Users,
  "Prayer": Cross,
  "Bible Study": BookOpen,
  "Youth Ministry": Baby,
  "Young Adults": Coffee,
  "Men's Group": Users,
  "Women's Group": Heart,
  "Family": Users,
  "Music & Choir": Music,
  "Service & Volunteering": HandHeart,
  "Social": MessageCircle,
  "Education": GraduationCap,
  "Sports & Recreation": Dumbbell,
  "Professional": Briefcase,
  "Support": Heart,
  "Other": Users
};

export const categoryColors = {
  "General": "#6B665E",
  "Prayer": "#8B2E2E",
  "Bible Study": "#556B2F",
  "Youth Ministry": "#4169E1",
  "Young Adults": "#D4AF37",
  "Men's Group": "#2F4F4F",
  "Women's Group": "#DB7093",
  "Family": "#20B2AA",
  "Music & Choir": "#9370DB",
  "Service & Volunteering": "#8B2E2E",
  "Social": "#FF6347",
  "Education": "#4682B4",
  "Sports & Recreation": "#32CD32",
  "Professional": "#708090",
  "Support": "#DDA0DD",
  "Other": "#6B665E"
};
